import styled from 'styled-components'
import {palette} from 'styled-tools'

export const FormerPrice = styled.div`
  color: ${palette('red')};
  text-decoration: line-through;
`
